import { Component, OnInit, inject } from '@angular/core';
import { DATA_SELECTOR_INJECTION_TOKEN } from '@aiwyn/shared';

@Component({
  selector: 'app-client-request-services',
  templateUrl: './client-request-services.component.html',
  styleUrls: ['./client-request-services.component.scss'],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'client-request-services',
    },
  ],
  standalone: false,
})
export class ClientRequestServicesComponent implements OnInit {
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  constructor() { }

  ngOnInit(): void {
  }

}
